import { render, staticRenderFns } from "./MessageLog.vue?vue&type=template&id=59612d44&scoped=true&"
import script from "./MessageLog.vue?vue&type=script&lang=js&"
export * from "./MessageLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59612d44",
  null
  
)

export default component.exports